<div class="rs-control-person">
  <div class="rs-control-person__title">{{'terms-and-agreement.required-person-information' | translate}}</div>
  <div class="rs-control-person__form">
    <rs-individual-form [individualForm]="controlPersonForm" [addressForm]="controlPersonForm"></rs-individual-form>
  </div>
  <rs-section-footer buttonText="save" [disabled]="saveButtonDisabled()" (accepted)="createControlPerson()"></rs-section-footer>
</div>
